import isNil from 'lodash/isNil'

import M0 from 'api/migrate/M0'
import M1 from 'api/migrate/M1'
import M2 from 'api/migrate/M2'
import M3 from 'api/migrate/M3'
import M4 from 'api/migrate/M4'
import M5 from 'api/migrate/M5'
import M6 from 'api/migrate/M6'

/**
 * Checks the current site config version and runs migration to upgrade the config to the current code version.
 *
 * @param {Object} config
 * @returns {Object} config
 */
export default function (config) {
  if (isNil(config)) {
    console.log('Invalid config file!')
    return config
  }
  config = M0(config)
  config = M1(config)
  config = M2(config)
  config = M3(config)
  config = M4(config)
  config = M5(config)
  config = M6(config)
  return config
}
